import React from "react";
import {
    BrowserRouter,
    Routes,
    Route,
} from "react-router-dom";

import Home from "./Home";
import PdfViewer from "./PdfViewer";


function Router() {
    return (
        <>
            <BrowserRouter>
                <Routes>
                    <Route
                        exact
                        path="/"
                        element={<Home />}
                    />
                    <Route path="/pdf/:name" element={<PdfViewer />} />

                </Routes>
            </BrowserRouter >
        </>
    );
}

export default Router;